import { useState, useRef, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FileClock } from "lucide-react";
import { config } from "../../Environment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const ElapsedTime = ({ processId, userData = {}, itemkey, startValue, stopValue, content, onChange }) => {

  const { t } = useTranslation();

  console.log(`[ElapsedTime] content`);
  console.log(content);
  console.log(`[ElapsedTime] startValue ${JSON.stringify(startValue)} stopValue ${JSON.stringify(stopValue)}`);

  // keep the same timestamp value across re-renders
  const elapsedValue = useMemo(() => {
    if (startValue && stopValue) {
      const start = Number(startValue);
      const stop = Number(stopValue);
      const elapsed = stop - start;
      console.log(`[ElapsedTime] elapsed ${JSON.stringify(elapsed)}`);
      return elapsed;
    }
    return null;
  }, [startValue, stopValue]);

  useEffect(() => {
    onChange(content.key, elapsedValue);
  }, [elapsedValue]);

  return (
    <div className="mt-3 text-start">
      {content.visible ? (
        <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-300 shadow-sm">
          <FileClock className="w-4 h-4 text-emerald-600" />
          <div>
            <span className="text-xs font-semibold text-gray-700 block">
              {content.label || t("elapsed_time")}
            </span>
            <span className="text-sm font-mono font-bold text-emerald-700">
              {elapsedValue}ms
            </span>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ElapsedTime;
